import { useState } from 'react';
import { supabase } from '../supabaseClient';

export const useSearchRun = () => {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [runId, setRunId] = useState(null);
  const [creditsUsed, setCreditsUsed] = useState(0);

  const translateQuery = async (query, searchTarget, empresaContextId) => {
    const { data, error: err } = await supabase.functions.invoke('agent-search-composer', {
      body: { query, search_target: searchTarget, empresa_context_id: empresaContextId },
    });
    if (err) return { success: false, error: err.message };
    if (!data?.ok) return { success: false, error: data?.error };
    return { success: true, data: data.data };
  };

  const executeSearch = async ({ searchTarget, filters, savedSearchId, naturalLanguageQuery, empresaContextId, decidedBy, autoClassify = true, autoEnrichTopN = 0, saveAs }) => {
    setLoading(true);
    setError(null);
    try {
      const fnName = searchTarget === 'people' ? 'agent-people-search' : 'agent-company-search';
      const body = {
        decided_by: decidedBy,
        auto_classify: autoClassify,
      };
      if (searchTarget === 'people') body.auto_enrich_top_n = autoEnrichTopN;
      if (savedSearchId) body.saved_search_id = savedSearchId;
      else if (naturalLanguageQuery) body.natural_language_query = naturalLanguageQuery;
      else body.filters = filters;
      if (empresaContextId) body.empresa_context_id = empresaContextId;
      if (saveAs) body.save_as = saveAs;

      const { data, error: err } = await supabase.functions.invoke(fnName, { body });
      if (err) throw new Error(err.message);
      if (!data?.ok) throw new Error(data?.error || 'Falha na busca');

      const d = data.data;
      setResults({
        searchTarget,
        apolloResults: d.apollo_results || [],
        classifications: (d.ai_classification?.classifications) || extractClassifications(d),
        summary: d.classification_summary,
        totalCount: d.total_count,
        empresaContextId,
      });
      setRunId(d.run_id);
      setCreditsUsed(d.credits_used || 0);
      return { success: true, data: d };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  const enrichPeople = async ({ apolloPersonIds, targetEmpresaId, createInCrm, decidedBy }) => {
    const { data, error: err } = await supabase.functions.invoke('agent-people-enrich', {
      body: { apollo_person_ids: apolloPersonIds, target_empresa_id: targetEmpresaId, create_in_crm: createInCrm, decided_by: decidedBy },
    });
    if (err) return { success: false, error: err.message };
    if (!data?.ok) return { success: false, error: data?.error };
    return { success: true, data: data.data };
  };

  const reset = () => { setResults(null); setError(null); setRunId(null); setCreditsUsed(0); };

  return { results, loading, error, runId, creditsUsed, executeSearch, translateQuery, enrichPeople, reset };
};

// Best-effort: tentar pegar classifications de outros campos se API mudar
function extractClassifications(d) {
  if (Array.isArray(d.classifications)) return d.classifications;
  return [];
}
